<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <BaseBodyDialog 
      :title="`SỬA LỚP HỌC`"
      :loading="loading"
      @close="cancel"
      @save="save"
    >
      <ClassInfoForm v-if="classData.id" :classData="classData" ref="form" />
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import ClassInfoForm from '@/components/basic/form/ClassInfoForm'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog'
import { mapActions } from 'vuex'
import { Class, Teaching, Subject } from '@/plugins/api'
import get from 'lodash-es/get'
import chunk from 'lodash-es/chunk'

export default {
  components: {
    ClassInfoForm,
    BaseBodyDialog
  },
  props: {
    state: Boolean,
    classData: Object,
    slots: Array,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions('classDetail', ['updateClass', 'updateTeaching']),
    async save() {
      if (!this.$refs.form.validate()) return
      this.loading = true
      this.$loading.active = true

      const data = this.$refs.form.getData()
      const classesFilter = await Class.fetch({ id_ne: this.classData.id })
      if (classesFilter.find((c) => c.title === data.title)) {
        this.$alert.error('Tên lớp đã tồn tại')
        this.$loading.active = false
        this.loading = false
        return
      }

      try {
        const data = this.$refs.form.getData()
        if (get(this.classData, 'division.id') !== data.division) {
          // sửa phân ban thì tạo lại giảng dạy
          const teachings = await Teaching.fetch({
            class: this.classData.id,
          })

          const groups = chunk(teachings, 5)
          for (let subTeachings of groups) {
            await Promise.all(
              subTeachings.map(async (t) => {
                return Teaching.remove(t.id)
              })
            )
          }

          const classData = await this.updateClass({ id: this.classData.id, ...data })
          const subjects = await Subject.fetch({ division: classData.division.id })
          const groups2 = chunk(subjects, 5)

          const grade = `00${classData.grade.gradeNumber}`.substr(`00${classData.grade.gradeNumber}`.length - 2)
          for (let subSubjects of groups2) {
            await Promise.all(
              subSubjects.map(async (subject) => {
                const sgIndex = `00${subject.subjectGroup && subject.subjectGroup.index}`.substr(
                  `00${subject.subjectGroup && subject.subjectGroup.index}`.length - 2
                )
                const tags = grade + classData.title + sgIndex
                return Teaching.create({
                  class: classData.id,
                  grade: classData.grade.id,
                  subject: subject.id,
                  subjectGroup: get(subject.subjectGroup, 'id'),
                  tags,
                })
              })
            )
          }
        } else {
          if (this.classData.grade.id !== data.grade) {
            // cập nhật Học phần, cập nhật giảng dạy
            const teachings = await Teaching.fetch({
              class: this.classData.id,
            })

            const groups = chunk(teachings, 5)
            for (let subTeachings of groups) {
              await Promise.all(
                subTeachings.map(async (t) => {
                  return this.updateTeaching({ id: t.id, grade: data.grade })
                })
              )
            }
          }

          await this.updateClass({ id: this.classData.id, ...data })
        }

        this.dialog = false
        this.$alert.updateSuccess()
      } catch (error) {
        console.error(error)
        this.$alert.updateError()
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
      this.$refs.form.resetDefault()
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
